import React from 'react';

const Paginacion = ({ paginado, onPageChange }) => {
  const { page, totalPaginas } = paginado;

  const handlePrevious = () => {
    if (page > 1) {
      onPageChange(page - 1);
    }
  };

  const handleNext = () => {
    if (page < totalPaginas) {
      onPageChange(page + 1);
    }
  };

  const handleLast = () => {
    if (page < totalPaginas) {
      onPageChange(totalPaginas);
    }
  };

  const handleFirst = () => {
    if (page > 1) {
      onPageChange(1);
    }
  };

  // 🔢 Calcular el rango de páginas para el bloque actual (10 en 10)
  const blockSize = 10;
  const startPage = Math.floor((page - 1) / blockSize) * blockSize + 1;
  const endPage = Math.min(startPage + blockSize - 1, totalPaginas);

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  // 🔁 Funciones para saltar de bloque en bloque
  const handlePrevBlock = () => {
    const prevBlockPage = Math.max(startPage - blockSize, 1);
    if (page > 1) {
      onPageChange(prevBlockPage);
    }
  };

  const handleNextBlock = () => {
    const nextBlockPage = startPage + blockSize;
    if (nextBlockPage <= totalPaginas) {
      onPageChange(nextBlockPage);
    }
  };

  return (
    <div className="pagination">
      <button onClick={handleFirst} disabled={page <= 1}>
        Primero
      </button>

      <button onClick={handlePrevious} disabled={page <= 1}>
        Anterior
      </button>

      {/* « Saltar bloque anterior */}
      <button onClick={handlePrevBlock} disabled={startPage === 1}>
        «
      </button>

      {/* 🔢 Números de página */}
      {pageNumbers.map((num) => (
        <button
          key={num}
          onClick={() => onPageChange(num)}
          className={`page-number ${num === page ? 'active' : ''}`}
          disabled={num === page}
        >
          {num}
        </button>
      ))}

      {/* » Saltar bloque siguiente */}
      <button onClick={handleNextBlock} disabled={startPage + blockSize > totalPaginas}>
        »
      </button>

      <button onClick={handleNext} disabled={page >= totalPaginas}>
        Siguiente
      </button>

      <button onClick={handleLast} disabled={page >= totalPaginas}>
        Último
      </button>
    </div>
  );
};

export default Paginacion;
